import { DRAWDATAALL } from "../../actions/portal/";

export default function(state = "", action) {
  switch (action.type) {
    case DRAWDATAALL:
      return action.payload;
    default:
  }

  return state;
}
